module.exports = __webpack_public_path__ + "static/img/增值税管理云5.ee5bd11c.png";